import React, { useState } from "react";
import { Button, Card, Col, Container, FloatingLabel, FormControl, Row } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import logo from "../color-logo.svg";

const VollmachtSignPage = () => {

    // change fields bools
    const [changeName, setChangeName] = useState(false);
    const [changeAddress, setChangeAddress] = useState(false);
    const [changeVat, setChangeVat] = useState(false)
    const [changeBirthdate, setChangeBirthdate] = useState(false);

    let dataPrivat = { company_type: "person", name: "Danijel Popovic", address: "Tullnerbachstraße 7/2/21, 3002 Purkersdorf", x_datebirth: "17.11.1987" };
    let dataGewerbe = { company_type: "company", name: "Ein Test Unternehmen GmbH", address: "Tullnerbachstraße 7/2/21, 3002 Purkersdorf", vat: "ATU12731231" };
    const data = dataGewerbe;

    return (
        <Container fluid>
            <Container>
                <Row className="mt-5 align-items-center">
                    <Col xs="6">
                        <h5 className="text-energo">Vollmacht</h5>
                        <p className="text-muted">Wir benötigen ein Unterschrift von Ihnen</p>
                    </Col>
                    <Col xs="6" className="text-end">
                        <img src={logo} width={100} />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col xs="12" xl="5">
                        <Card>
                            <Card.Body>
                                <b>Kudendaten</b>
                                <Row className="mt-3">
                                    <Col>
                                        <p><small className="text-muted">{changeName ? "Änder Sie Ihre Name" : "Name"}</small> &nbsp;
                                            {changeName ?
                                                <Row className="align-items-center">
                                                    <Col xs="9">
                                                        <FloatingLabel label="Name ändern">
                                                            <FormControl value={data.name} />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xs="3">
                                                        <Button onClick={() => setChangeName(false)} className="btn-energo">Ändern</Button>
                                                    </Col>
                                                </Row>
                                                :
                                                <>
                                                    {data.name} &nbsp; <small className="text-energo">
                                                        <a href="#" className="link-energo" onClick={e => { e.preventDefault(); setChangeName(true) }}>ändern</a></small>
                                                </>
                                            }
                                        </p>
                                        <p>
                                            <small className="text-muted">
                                                {changeAddress ? "Bitte geben Sie richtige Adresse ein" : "Adresse"} &nbsp;
                                            </small> &nbsp;
                                            {changeAddress ?
                                                <Row>
                                                    <Col xs="9">
                                                        <FloatingLabel label="Adresse">
                                                            <FormControl />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xs="3">
                                                        <Button className="btn-energo">Ändern</Button>
                                                    </Col>
                                                </Row>
                                                :
                                                <>
                                                    {data.address} <small><a href="#" className="link-energo">ändern</a></small>
                                                </>
                                            }
                                        </p>
                                        <p>
                                            {data.company_type === "person" ?
                                                changeBirthdate ?
                                                    <>
                                                        <small className="text-muted">Geben Sie uns Ihre Geburtsdatum bekannt</small>
                                                        <FloatingLabel label="Geburtsdatum">
                                                            <FormControl type="date" />
                                                        </FloatingLabel>
                                                    </> :
                                                    <>
                                                        <small className="text-muted">Geburtsdatum</small> &nbsp; {data.x_datebirth} &nbsp; <small><a href="#" className="link-energo">ändern</a></small>
                                                    </>
                                                :
                                                changeVat ?
                                                    <>
                                                        <small className="text-muted">ATU Nummer ändern</small>
                                                        <FloatingLabel label="ATU Nummer">
                                                            <FormControl />
                                                        </FloatingLabel>
                                                    </> :
                                                    <>
                                                        <small className="text-muted">ATU Nummer</small> &nbsp; {data.vat} &nbsp; <small><a href="#" className="link-energo">ändern</a></small>
                                                    </>
                                            }
                                        </p>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xl="7">
                        <Card>
                            <Card.Body>
                                <p><b>
                                    Damit wir für Sie tätig werden können, ist es notwendig, dass Sie uns
                                    bevollmächtigen. Die Vollmacht umfasst folgende Punkte:
                                </b></p>
                                <ul>
                                    <li>ENERGO vergleicht Marktpreise und schließt nach Bedarf und Möglichkeit einen günstigeren Vertrag für Sie ab.</li>
                                    <li>ENERGO darf in Ihrem Namen Energielieferverträge abschließen, kündigen oder ändern.</li>
                                    <li>Ihre Mitgliedschaft bzw. diese Vollmacht kann JEDERZEIT gekündigt werden.</li>
                                    <li>Für das Service von ENERGO wird ein Honorar von EUR 0,0098 pro kWh Strom bzw. EUR 0,0065 pro kWh Gas verrechnet (inkl. 20% USt). Beispiel: EUR 28,42/Jahr bei 2900 kWh Strom.</li>
                                    <li>ENERGO darf Ihre Anlagen in die Grundversorgung melden, wenn dies für Sie wirtschaftlich günstig ist. Dafür werden EUR 60,00 verrechnet.</li>
                                </ul>
                                <br />
                                <a href="#" className="link-energo">Ganze Vollmacht können Sie hir ansehen</a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Row className="mt-3 justify-content-center">
                <Col>
                    <Col style={{ maxWidth: 440, maxHeight: 50, marginLeft: "auto", marginRight: "auto" }}>
                        <p><b>Hier Unterschreiben</b></p>
                        <SignatureCanvas
                            penColor="black"
                            backgroundColor="rgba(0,0,0,0)"
                            canvasProps={{ className: 'sigCanvas', }}
                        />
                    </Col>
                </Col>
            </Row>
        </Container>
    )
}
export default VollmachtSignPage;